import React, { useState, useEffect } from 'react';
import axiosInstance from '../utils/axiosInstance';
import {
  FaEdit, FaPlus, FaTimes, FaLayerGroup, FaLink,
  FaSortAmountDown, FaSearch, FaSync, FaChevronLeft,
  FaChevronRight, FaFilter, FaTag, FaTrash
} from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/* ─── küçük yardımcılar ──────────────────────────────────── */
const inp = { width:'100%', padding:'10px 13px', background:'#0d0e12', border:'1px solid rgba(255,255,255,.08)', borderRadius:10, color:'#f1f5f9', fontSize:'.83rem', fontFamily:"'Outfit',sans-serif", outline:'none', transition:'border-color .2s, box-shadow .2s' };
const lbl = { display:'block', fontSize:'.63rem', fontWeight:600, textTransform:'uppercase', letterSpacing:'1px', color:'rgba(255,255,255,.26)', marginBottom:6 };
const percentColor = p => p <= 20 ? '#10b981' : p <= 50 ? '#f59e0b' : '#ef4444';

const BonusManagement = () => {
  const [bonuses,           setBonuses]           = useState([]);
  const [categories,        setCategories]        = useState([]);
  const [loading,           setLoading]           = useState(true);
  const [isSystemActive,    setIsSystemActive]    = useState(true);
  const [loadingStatus,     setLoadingStatus]     = useState(true);
  const [showModal,         setShowModal]         = useState(false);
  const [showCatModal,      setShowCatModal]      = useState(false);
  const [currentBonus,      setCurrentBonus]      = useState(null);
  const [newCatName,        setNewCatName]        = useState('');
  const [isSubmittingCat,   setIsSubmittingCat]   = useState(false);
  const [searchTerm,        setSearchTerm]        = useState('');
  const [showSearch,        setShowSearch]        = useState(false);
  const [currentPage,       setCurrentPage]       = useState(1);
  const itemsPerPage = 10;

  const [formData, setFormData] = useState({
    name:'', bonusType:'', bonusPercent:0, category:'',
    order:0, status:true, minDepositAmount:0, maxDepositAmount:0,
    minAmount:0, maxAmount:0, boPanelID:0, boPanelType:0,
    description: []
  });

  /* ─── fetch ─────────────────────────────────────────────── */
  const fetchBonuses = async () => {
    setLoading(true);
    try { const r = await axiosInstance.get('/bonus/all'); setBonuses(r.data); }
    catch { toast.error('Bonuslar yüklenemedi.'); }
    finally { setLoading(false); }
  };
  const fetchCategories = async () => {
    try { const r = await axiosInstance.get('/bonus/categories'); setCategories(r.data); }
    catch { console.error('Kategoriler yüklenemedi'); }
  };
  const fetchStatus = () => {
    axiosInstance.get('/siteSettings')
      .then(r => setIsSystemActive(r.data.bonusRequestsEnabled))
      .catch(console.error)
      .finally(() => setLoadingStatus(false));
  };

  useEffect(() => {
    fetchBonuses(); fetchCategories(); fetchStatus();
    const iv = setInterval(fetchStatus, 20000);
    return () => clearInterval(iv);
  }, []);

  /* ─── kategori işlemleri ──────────────────────────────── */
  const getCatName = id => {
    const c = categories.find(c => Number(c.categoryId) === Number(id));
    return c ? c.name : 'Genel';
  };
  const handleAddCat = async (e) => {
    e.preventDefault();
    if (!newCatName.trim()) return;
    setIsSubmittingCat(true);
    try { await axiosInstance.post('/bonus/categories', { name: newCatName }); toast.success('Kategori eklendi!'); setNewCatName(''); fetchCategories(); }
    catch { toast.error('Ekleme başarısız.'); }
    finally { setIsSubmittingCat(false); }
  };
  const handleDelCat = async (id) => {
    if (!window.confirm('Bu kategoriyi silmek istediğinize emin misiniz?')) return;
    try { await axiosInstance.delete(`/bonus/categories/${id}`); toast.success('Kategori silindi.'); fetchCategories(); }
    catch { toast.error('Silme başarısız.'); }
  };

  /* ─── bonus form ─────────────────────────────────────── */
  const handleEdit = (bonus) => { setCurrentBonus(bonus); setFormData({...bonus}); setShowModal(true); };
  const handleAddNew = () => {
    setCurrentBonus(null);
    setFormData({ name:'', bonusType:'', bonusPercent:0, category:'', order:0, status:true, minDepositAmount:0, maxDepositAmount:0, minAmount:0, maxAmount:0, boPanelID:0, boPanelType:0, description:[], allowedDays:[] });
    setShowModal(true);
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(p => ({ ...p, [name]: type === 'checkbox' ? checked : type === 'number' ? Number(value) : value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Textarea onBlur tetiklenmediyse diye submit anında da parse et
    const textarea = e.target.querySelector('textarea');
    let finalData = { ...formData };
    if (textarea) {
      const raw = textarea.value;
      const maddeler = raw
        .split(/\n(?=\d+\. )/)
        .map(s => s.replace(/^\d+\.\s*/, '').trim())
        .filter(Boolean);
      finalData = { ...finalData, description: maddeler.length > 0 ? maddeler : raw.split('\n').map(s=>s.trim()).filter(Boolean) };
    }
    try {
      if (currentBonus) { await axiosInstance.put(`/bonus/update/${currentBonus._id}`, finalData); toast.success('Bonus güncellendi!'); }
      else               { await axiosInstance.post('/bonus/create', finalData); toast.success('Yeni bonus oluşturuldu!'); }
      setShowModal(false); fetchBonuses();
    } catch (err) { toast.error(`Hata: ${err.response?.data?.message || 'İşlem başarısız'}`); }
  };

  /* ─── filtre & sayfalama ─────────────────────────────── */
  const filtered   = bonuses.filter(b => b.name?.toLowerCase().includes(searchTerm.toLowerCase()) || b.bonusType?.toLowerCase().includes(searchTerm.toLowerCase()));
  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const current    = filtered.slice((currentPage-1)*itemsPerPage, currentPage*itemsPerPage);

  /* ─── render ─────────────────────────────────────────── */
  return (
    <div style={{ minHeight:'100vh', background:'#090a0c', padding:'28px 28px 40px', color:'#e2e8f0', fontFamily:"'Outfit','Inter',sans-serif", boxSizing:'border-box' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');
        *{box-sizing:border-box}
        .bm-row:hover{background:rgba(255,255,255,.03)!important;transform:translateX(2px)}
        .bm-btn:hover{filter:brightness(1.2);transform:scale(1.07)}
        .bm-inp:focus{border-color:#f27127!important;box-shadow:0 0 0 3px rgba(242,113,39,.1)!important}
        .bm-tog:hover{filter:brightness(1.1);transform:translateY(-1px)}
        @keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:none}}
        .bm-fade{animation:fadeUp .3s ease both}
        .bm-scroll::-webkit-scrollbar{width:3px}
        .bm-scroll::-webkit-scrollbar-thumb{background:rgba(255,255,255,.08);border-radius:4px}
        @keyframes pulseDot{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.4;transform:scale(.7)}}
      `}</style>

      {/* ── Header ── */}
      <div className="bm-fade" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24, flexWrap:'wrap', gap:12 }}>
        <div style={{ display:'flex', alignItems:'center', gap:14 }}>
          <div style={{ width:44, height:44, borderRadius:13, background:'rgba(242,113,39,.1)', border:'1px solid rgba(242,113,39,.25)', display:'flex', alignItems:'center', justifyContent:'center', color:'#f27127', fontSize:'1.1rem', boxShadow:'0 0 18px rgba(242,113,39,.1)' }}><FaLayerGroup /></div>
          <div>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <h2 style={{ margin:0, fontSize:'1.2rem', fontWeight:700, color:'#f8fafc', letterSpacing:'-.3px' }}>Bonus Yönetimi</h2>
              <span style={{ padding:'2px 10px', borderRadius:20, background:'rgba(242,113,39,.1)', color:'#f27127', border:'1px solid rgba(242,113,39,.2)', fontSize:'.7rem', fontWeight:700 }}>{filtered.length}</span>
            </div>
            <p style={{ margin:'3px 0 0', fontSize:'.71rem', color:'rgba(255,255,255,.22)' }}>Bonus tanımları ve kategori yönetimi</p>
          </div>
        </div>

        <div style={{ display:'flex', gap:9, alignItems:'center', flexWrap:'wrap' }}>
          {/* Sistem durumu pill */}
          <div style={{ display:'flex', alignItems:'center', gap:7, padding:'7px 13px', borderRadius:10, background: isSystemActive?'rgba(16,185,129,.08)':'rgba(239,68,68,.08)', border:`1px solid ${isSystemActive?'rgba(16,185,129,.2)':'rgba(239,68,68,.18)'}`, fontSize:'.72rem', fontWeight:700, letterSpacing:'.5px', color: isSystemActive?'#10b981':'#ef4444' }}>
            <span style={{ width:7, height:7, borderRadius:'50%', background: isSystemActive?'#10b981':'#ef4444', display:'inline-block', animation:'pulseDot 2s infinite' }} />
            {loadingStatus ? '...' : isSystemActive ? 'Sistem Aktif' : 'Sistem Kapalı'}
          </div>

          <button onClick={() => setShowSearch(s=>!s)} style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 13px', borderRadius:10, border:`1px solid ${showSearch?'rgba(242,113,39,.3)':'rgba(255,255,255,.08)'}`, background: showSearch?'rgba(242,113,39,.08)':'rgba(255,255,255,.04)', color: showSearch?'#f27127':'rgba(255,255,255,.4)', fontSize:'.78rem', fontWeight:600, cursor:'pointer', fontFamily:'inherit', transition:'all .15s' }}>
            <FaFilter style={{ fontSize:'.7rem' }} /> Filtre
          </button>
          <button onClick={() => setShowCatModal(true)} style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 13px', borderRadius:10, border:'1px solid rgba(255,255,255,.08)', background:'rgba(255,255,255,.04)', color:'rgba(255,255,255,.45)', fontSize:'.78rem', fontWeight:600, cursor:'pointer', fontFamily:'inherit', transition:'all .15s' }}>
            <FaTag style={{ fontSize:'.7rem' }} /> Kategoriler
          </button>
          <button onClick={handleAddNew} style={{ display:'flex', alignItems:'center', gap:7, padding:'9px 16px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#f27127,#c44b0a)', color:'#fff', fontSize:'.79rem', fontWeight:700, cursor:'pointer', fontFamily:'inherit', boxShadow:'0 4px 14px rgba(242,113,39,.3)', transition:'all .15s' }}>
            <FaPlus /> Yeni Bonus
          </button>
        </div>
      </div>

      {/* ── Arama ── */}
      {showSearch && (
        <div style={{ position:'relative', marginBottom:18 }}>
          <FaSearch style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', color:'rgba(255,255,255,.25)', fontSize:'.85rem', pointerEvents:'none' }} />
          <input className="bm-inp" type="text" placeholder="Bonus adı veya tipi ara..." value={searchTerm}
            onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            style={{ ...inp, paddingLeft:40, background:'#111318', border:'1px solid rgba(255,255,255,.07)' }} />
        </div>
      )}

      {/* ── Tablo ── */}
      <div style={{ background:'#111318', border:'1px solid rgba(255,255,255,.06)', borderRadius:20, overflow:'hidden' }}>
        {/* Başlık */}
        <div style={{ display:'grid', gridTemplateColumns:'100px 1fr 80px 160px 160px 130px 90px 60px', padding:'12px 18px', borderBottom:'1px solid rgba(255,255,255,.05)', background:'rgba(0,0,0,.2)' }}>
          {['KOD','BONUS DETAYI','ORAN','YATIRIM ŞARTI','BONUS LİMİTİ','PANEL','DURUM',''].map((h,i) => (
            <div key={i} style={{ fontSize:'.59rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.2px', color:'rgba(255,255,255,.2)', textAlign: i>=6?'center':'left' }}>{h}</div>
          ))}
        </div>

        <div style={{ padding:'6px 8px' }}>
          {loading ? (
            Array.from({length:5}).map((_,i) => <div key={i} style={{ height:52, borderRadius:12, marginBottom:4, background:'rgba(255,255,255,.03)' }} />)
          ) : current.length > 0 ? current.map(bonus => {
            const pc = percentColor(bonus.bonusPercent);
            return (
              <div key={bonus._id} className="bm-row" style={{ display:'grid', gridTemplateColumns:'100px 1fr 80px 160px 160px 130px 90px 60px', alignItems:'center', padding:'11px 10px', borderRadius:12, marginBottom:4, background:'rgba(255,255,255,.015)', border:'1px solid rgba(255,255,255,.03)', position:'relative', overflow:'hidden', transition:'all .15s' }}>
                <div style={{ position:'absolute', left:0, top:'15%', bottom:'15%', width:3, borderRadius:'0 3px 3px 0', background:'#f27127', boxShadow:'0 0 8px rgba(242,113,39,.5)' }} />
                {/* Kod */}
                <div style={{ paddingLeft:8 }}>
                  <span style={{ padding:'3px 9px', borderRadius:7, background:'rgba(242,113,39,.1)', border:'1px solid rgba(242,113,39,.2)', color:'#f27127', fontSize:'.68rem', fontWeight:700, fontFamily:'monospace' }}>{bonus.bonusType}</span>
                </div>
                {/* Detay */}
                <div>
                  <div style={{ fontSize:'.83rem', fontWeight:600, color:'#e2e8f0', marginBottom:4 }}>{bonus.name}</div>
                  <div style={{ display:'flex', gap:5, flexWrap:'wrap', alignItems:'center' }}>
                    <span style={{ padding:'2px 8px', borderRadius:6, background:'rgba(139,92,246,.1)', border:'1px solid rgba(139,92,246,.2)', color:'#a78bfa', fontSize:'.62rem', fontWeight:600 }}>{getCatName(bonus.category)}</span>
                    <span style={{ display:'flex', alignItems:'center', gap:3, padding:'2px 8px', borderRadius:6, background:'rgba(255,255,255,.05)', color:'rgba(255,255,255,.3)', fontSize:'.62rem' }}><FaSortAmountDown style={{ fontSize:'.55rem' }} />#{bonus.order}</span>
                    {(() => {
                      const GUNLER = [{n:1,k:'Pzt'},{n:2,k:'Sal'},{n:3,k:'Çar'},{n:4,k:'Per'},{n:5,k:'Cum'},{n:6,k:'Cmt'},{n:0,k:'Paz'}];
                      const days = bonus.allowedDays || [];
                      const bugun = new Date().getDay();
                      if (days.length === 0) return (
                        <span style={{ display:'flex', alignItems:'center', gap:3, padding:'2px 8px', borderRadius:6, background:'rgba(16,185,129,.08)', border:'1px solid rgba(16,185,129,.18)', color:'#10b981', fontSize:'.6rem', fontWeight:600 }}>
                          <span style={{ width:4, height:4, borderRadius:'50%', background:'#10b981', display:'inline-block' }} />Her gün
                        </span>
                      );
                      const bugunDahil = days.includes(bugun);
                      return (
                        <span style={{ display:'flex', alignItems:'center', gap:3, flexWrap:'wrap' }}>
                          {GUNLER.filter(g => days.includes(g.n)).map(g => {
                            const bugunMu = g.n === bugun;
                            return (
                              <span key={g.n} style={{
                                padding:'2px 7px', borderRadius:5, fontSize:'.6rem', fontWeight:700,
                                background: bugunMu ? 'rgba(74,222,128,.15)' : 'rgba(167,139,250,.08)',
                                border: bugunMu ? '1px solid rgba(74,222,128,.3)' : '1px solid rgba(167,139,250,.15)',
                                color: bugunMu ? '#4ade80' : 'rgba(167,139,250,.6)',
                              }}>{g.k}{bugunMu ? ' ✓' : ''}</span>
                            );
                          })}
                          {!bugunDahil && (
                            <span style={{ padding:'2px 6px', borderRadius:5, fontSize:'.58rem', background:'rgba(239,68,68,.08)', border:'1px solid rgba(239,68,68,.15)', color:'rgba(239,68,68,.5)' }}>Bugün kapalı</span>
                          )}
                        </span>
                      );
                    })()}
                  </div>
                </div>
                {/* Oran */}
                <div style={{ display:'flex', justifyContent:'center' }}>
                  <div style={{ width:46, height:46, borderRadius:'50%', border:`2px solid ${pc}44`, background:`radial-gradient(circle, ${pc}15 0%, transparent 70%)`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <span style={{ fontSize:'.72rem', fontWeight:800, color:pc }}>%{bonus.bonusPercent}</span>
                  </div>
                </div>
                {/* Yatırım şartı */}
                <div>
                  <div style={{ padding:'6px 10px', borderRadius:8, background:'rgba(0,0,0,.25)', border:'1px solid rgba(255,255,255,.05)' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:3 }}>
                      <span style={{ fontSize:'.62rem', color:'rgba(255,255,255,.3)' }}>Min</span>
                      <span style={{ fontSize:'.72rem', fontWeight:700, color:'#e2e8f0' }}>{bonus.minDepositAmount?.toLocaleString()} ₺</span>
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between' }}>
                      <span style={{ fontSize:'.62rem', color:'rgba(255,255,255,.3)' }}>Max</span>
                      <span style={{ fontSize:'.72rem', fontWeight:700, color:'#f59e0b' }}>{bonus.maxDepositAmount === 0 ? '∞' : `${bonus.maxDepositAmount?.toLocaleString()} ₺`}</span>
                    </div>
                  </div>
                </div>
                {/* Bonus limiti */}
                <div>
                  <div style={{ padding:'6px 10px', borderRadius:8, background:'rgba(0,0,0,.25)', border:'1px solid rgba(255,255,255,.05)' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:3 }}>
                      <span style={{ fontSize:'.62rem', color:'rgba(255,255,255,.3)' }}>Min</span>
                      <span style={{ fontSize:'.72rem', fontWeight:700, color:'#e2e8f0' }}>{bonus.minAmount?.toLocaleString()} ₺</span>
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between' }}>
                      <span style={{ fontSize:'.62rem', color:'rgba(255,255,255,.3)' }}>Max</span>
                      <span style={{ fontSize:'.72rem', fontWeight:700, color:'#f59e0b' }}>{bonus.maxAmount === 0 ? '∞' : `${bonus.maxAmount?.toLocaleString()} ₺`}</span>
                    </div>
                  </div>
                </div>
                {/* Panel */}
                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                  <FaLink style={{ color:'rgba(255,255,255,.2)', fontSize:'.65rem', flexShrink:0 }} />
                  <div>
                    <div style={{ fontSize:'.68rem', color:'rgba(255,255,255,.35)' }}>ID: <span style={{ color:'#cbd5e1', fontWeight:600 }}>{bonus.boPanelID}</span></div>
                    <div style={{ fontSize:'.68rem', color:'rgba(255,255,255,.35)' }}>Type: <span style={{ color:'#cbd5e1', fontWeight:600 }}>{bonus.boPanelType}</span></div>
                  </div>
                </div>
                {/* Durum */}
                <div style={{ display:'flex', justifyContent:'center' }}>
                  <span style={{ display:'inline-flex', alignItems:'center', gap:5, padding:'4px 11px', borderRadius:7, fontSize:'.62rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.4px', background: bonus.status?'rgba(16,185,129,.1)':'rgba(239,68,68,.1)', color: bonus.status?'#10b981':'#ef4444', border:`1px solid ${bonus.status?'rgba(16,185,129,.2)':'rgba(239,68,68,.2)'}` }}>
                    <span style={{ width:5, height:5, borderRadius:'50%', background: bonus.status?'#10b981':'#ef4444', display:'inline-block' }} />
                    {bonus.status ? 'Aktif' : 'Pasif'}
                  </span>
                </div>
                {/* Düzenle */}
                <div style={{ display:'flex', justifyContent:'center' }}>
                  <button className="bm-btn" onClick={() => handleEdit(bonus)} style={{ width:32, height:32, borderRadius:9, border:'none', cursor:'pointer', background:'rgba(99,102,241,.15)', color:'#818cf8', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.78rem', transition:'all .15s' }}><FaEdit /></button>
                </div>
              </div>
            );
          }) : (
            <div style={{ textAlign:'center', padding:'50px 0', color:'rgba(255,255,255,.15)', fontSize:'.85rem' }}>
              <FaLayerGroup style={{ fontSize:'2rem', opacity:.15, display:'block', margin:'0 auto 10px' }} />Bonus bulunamadı
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 18px', borderTop:'1px solid rgba(255,255,255,.05)', background:'rgba(0,0,0,.15)' }}>
            <span style={{ fontSize:'.72rem', color:'rgba(255,255,255,.2)' }}>
              Toplam <b style={{ color:'rgba(255,255,255,.45)' }}>{filtered.length}</b> kayıt • Sayfa <b style={{ color:'rgba(255,255,255,.45)' }}>{currentPage}</b>/{totalPages}
            </span>
            <div style={{ display:'flex', gap:5 }}>
              <button disabled={currentPage===1} onClick={() => setCurrentPage(p=>p-1)} style={{ width:32, height:32, borderRadius:8, border:'1px solid rgba(255,255,255,.08)', background:'rgba(255,255,255,.04)', color:'rgba(255,255,255,.3)', cursor:currentPage===1?'not-allowed':'pointer', display:'flex', alignItems:'center', justifyContent:'center', opacity:currentPage===1?.35:1 }}><FaChevronLeft style={{ fontSize:'.65rem' }} /></button>
              {Array.from({length:totalPages},(_,i)=>i+1).map(n => (
                <button key={n} onClick={() => setCurrentPage(n)} style={{ width:32, height:32, borderRadius:8, border:`1px solid ${currentPage===n?'rgba(242,113,39,.4)':'rgba(255,255,255,.08)'}`, background: currentPage===n?'rgba(242,113,39,.15)':'rgba(255,255,255,.04)', color: currentPage===n?'#f27127':'rgba(255,255,255,.3)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.75rem', fontWeight: currentPage===n?700:400 }}>{n}</button>
              ))}
              <button disabled={currentPage===totalPages} onClick={() => setCurrentPage(p=>p+1)} style={{ width:32, height:32, borderRadius:8, border:'1px solid rgba(255,255,255,.08)', background:'rgba(255,255,255,.04)', color:'rgba(255,255,255,.3)', cursor:currentPage===totalPages?'not-allowed':'pointer', display:'flex', alignItems:'center', justifyContent:'center', opacity:currentPage===totalPages?.35:1 }}><FaChevronRight style={{ fontSize:'.65rem' }} /></button>
            </div>
          </div>
        )}
      </div>

      {/* ══ BONUS MODAL ══ */}
      {showModal && (
        <div onClick={() => setShowModal(false)} style={{ position:'fixed', inset:0, zIndex:10000, background:'rgba(0,0,0,.8)', backdropFilter:'blur(10px)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div onClick={e=>e.stopPropagation()} style={{ width:'100%', maxWidth:660, background:'#111318', border:'1px solid rgba(242,113,39,.15)', borderRadius:22, overflow:'hidden', boxShadow:'0 32px 80px rgba(0,0,0,.7)', maxHeight:'90vh', display:'flex', flexDirection:'column' }}>
            {/* Modal header */}
            <div style={{ padding:'20px 24px 16px', borderBottom:'1px solid rgba(255,255,255,.05)', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ width:38, height:38, borderRadius:10, background:'rgba(242,113,39,.12)', border:'1px solid rgba(242,113,39,.25)', display:'flex', alignItems:'center', justifyContent:'center', color:'#f27127' }}><FaEdit /></div>
                <div>
                  <div style={{ fontWeight:700, fontSize:'.92rem', color:'#f8fafc' }}>{currentBonus ? 'Bonusu Düzenle' : 'Yeni Bonus Ekle'}</div>
                  <div style={{ fontSize:'.68rem', color:'rgba(255,255,255,.25)', marginTop:2 }}>Sistem parametrelerini yapılandırın</div>
                </div>
              </div>
              <button onClick={() => setShowModal(false)} style={{ width:30, height:30, borderRadius:8, border:'none', cursor:'pointer', background:'rgba(255,255,255,.06)', color:'rgba(255,255,255,.35)', display:'flex', alignItems:'center', justifyContent:'center' }}><FaTimes /></button>
            </div>

            <form onSubmit={handleSubmit} style={{ padding:'20px 24px 24px', overflowY:'auto', flex:1 }} className="bm-scroll">
              {/* Genel */}
              <div style={{ marginBottom:20 }}>
                <div style={{ fontSize:'.62rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.4px', color:'rgba(255,255,255,.18)', marginBottom:12 }}>Genel Bilgiler</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                  <div style={{ gridColumn:'1/-1' }}>
                    <label style={lbl}>Bonus Adı</label>
                    <input className="bm-inp" name="name" value={formData.name} onChange={handleChange} required style={inp} />
                  </div>
                  <div>
                    <label style={lbl}>Bonus Tipi (Kod)</label>
                    <input className="bm-inp" name="bonusType" value={formData.bonusType} onChange={handleChange} required style={inp} />
                  </div>
                  <div>
                    <label style={lbl}>Kategori</label>
                    <select className="bm-inp" name="category" value={formData.category} onChange={handleChange} required style={{ ...inp, cursor:'pointer' }}>
                      <option value="">Seçiniz...</option>
                      {categories.map(c => <option key={c._id} value={c.categoryId}>{c.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              {/* Finansal */}
              <div style={{ marginBottom:20 }}>
                <div style={{ fontSize:'.62rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.4px', color:'rgba(255,255,255,.18)', marginBottom:12 }}>Finansal Limitler & Oran</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                  <div><label style={lbl}>Bonus Yüzdesi (%)</label><input className="bm-inp" type="number" name="bonusPercent" value={formData.bonusPercent} onChange={handleChange} style={inp} /></div>
                  <div><label style={lbl}>Min. Yatırım (₺)</label><input className="bm-inp" type="number" name="minDepositAmount" value={formData.minDepositAmount} onChange={handleChange} style={inp} /></div>
                  <div><label style={lbl}>Max. Yatırım (₺)</label><input className="bm-inp" type="number" name="maxDepositAmount" value={formData.maxDepositAmount} onChange={handleChange} style={inp} /></div>
                  <div><label style={lbl}>Max. Bonus (₺)</label><input className="bm-inp" type="number" name="maxAmount" value={formData.maxAmount} onChange={handleChange} style={inp} /></div>
                </div>
              </div>

              {/* Sistem */}
              <div style={{ marginBottom:20 }}>
                <div style={{ fontSize:'.62rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.4px', color:'rgba(255,255,255,.18)', marginBottom:12 }}>Sistem & Görünüm</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr', gap:12 }}>
                  <div><label style={lbl}>BO Panel ID</label><input className="bm-inp" type="number" name="boPanelID" value={formData.boPanelID} onChange={handleChange} style={inp} /></div>
                  <div><label style={lbl}>BO Panel Type</label><input className="bm-inp" type="number" name="boPanelType" value={formData.boPanelType} onChange={handleChange} style={inp} /></div>
                  <div><label style={lbl}>Sıra</label><input className="bm-inp" type="number" name="order" value={formData.order} onChange={handleChange} style={inp} /></div>
                  <div>
                    <label style={lbl}>Yayın Durumu</label>
                    <div onClick={() => setFormData(p=>({...p, status:!p.status}))} style={{ height:42, borderRadius:10, border:`1px solid ${formData.status?'rgba(16,185,129,.3)':'rgba(239,68,68,.25)'}`, background: formData.status?'rgba(16,185,129,.08)':'rgba(239,68,68,.07)', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', gap:8, transition:'all .2s', userSelect:'none' }}>
                      <span style={{ width:8, height:8, borderRadius:'50%', background: formData.status?'#10b981':'#ef4444', display:'inline-block' }} />
                      <span style={{ fontSize:'.75rem', fontWeight:700, color: formData.status?'#10b981':'#ef4444' }}>{formData.status ? 'AKTİF' : 'PASİF'}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Talep Günleri */}
              {(() => {
                const GUNLER = [
                  {num:1,uzun:'Pazartesi'},{num:2,uzun:'Salı'},{num:3,uzun:'Çarşamba'},
                  {num:4,uzun:'Perşembe'},{num:5,uzun:'Cuma'},{num:6,uzun:'Cumartesi'},{num:0,uzun:'Pazar'},
                ];
                const seciliGunler = formData.allowedDays || [];
                const toggle = (num) => setFormData(p => {
                  const d = p.allowedDays || [];
                  return { ...p, allowedDays: d.includes(num) ? d.filter(x=>x!==num) : [...d, num] };
                });
                return (
                  <div style={{ marginBottom:24 }}>
                    <div style={{ fontSize:'.62rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.4px', color:'rgba(255,255,255,.18)', marginBottom:6 }}>Talep Günleri</div>
                    <div style={{ fontSize:'.67rem', color:'rgba(255,255,255,.22)', marginBottom:10 }}>
                      Boş bırakılırsa <strong style={{color:'rgba(255,255,255,.45)'}}>her gün</strong> talep edilebilir.
                    </div>
                    {/* Seçili günler göstergesi + dropdown tetikleyici */}
                    <div style={{ position:'relative' }}>
                      <div
                        onClick={() => setFormData(p => ({ ...p, _gunDropAcik: !p._gunDropAcik }))}
                        style={{
                          display:'flex', alignItems:'center', gap:8, padding:'10px 13px',
                          borderRadius:10, cursor:'pointer', userSelect:'none',
                          border:'1px solid rgba(167,139,250,.2)',
                          background:'rgba(255,255,255,.04)',
                          minHeight:42,
                        }}
                      >
                        {seciliGunler.length === 0
                          ? <span style={{ fontSize:'.76rem', color:'rgba(255,255,255,.22)' }}>Gün seçilmedi — her gün aktif</span>
                          : <div style={{ display:'flex', flexWrap:'wrap', gap:5, flex:1 }}>
                              {GUNLER.filter(g => seciliGunler.includes(g.num)).map(g => (
                                <span key={g.num} style={{
                                  padding:'2px 10px', borderRadius:6,
                                  background:'rgba(167,139,250,.15)', border:'1px solid rgba(167,139,250,.3)',
                                  color:'#a78bfa', fontSize:'.7rem', fontWeight:700,
                                }}>{g.uzun}</span>
                              ))}
                            </div>
                        }
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.3)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                          style={{ marginLeft:'auto', flexShrink:0, transition:'transform .18s', transform: formData._gunDropAcik ? 'rotate(180deg)' : 'none' }}>
                          <path d="M6 9l6 6 6-6"/>
                        </svg>
                      </div>

                      {/* Dropdown listesi */}
                      {formData._gunDropAcik && (
                        <>
                          <div onClick={() => setFormData(p=>({...p,_gunDropAcik:false}))} style={{ position:'fixed',inset:0,zIndex:49 }} />
                          <div style={{
                            position:'absolute', top:'calc(100% + 6px)', left:0, right:0, zIndex:50,
                            background:'#1a1535', border:'1px solid rgba(167,139,250,.2)',
                            borderRadius:12, overflow:'hidden',
                            boxShadow:'0 12px 40px rgba(0,0,0,.6)',
                          }}>
                            {GUNLER.map((g, i, arr) => {
                              const sec = seciliGunler.includes(g.num);
                              return (
                                <div key={g.num}
                                  onClick={() => toggle(g.num)}
                                  style={{
                                    display:'flex', alignItems:'center', gap:11, padding:'11px 14px',
                                    cursor:'pointer', userSelect:'none',
                                    borderBottom: i < arr.length-1 ? '1px solid rgba(255,255,255,.04)' : 'none',
                                    background: sec ? 'rgba(167,139,250,.08)' : 'transparent',
                                    transition:'background .12s',
                                  }}
                                  onMouseEnter={e => { if(!sec) e.currentTarget.style.background='rgba(255,255,255,.04)'; }}
                                  onMouseLeave={e => { e.currentTarget.style.background = sec ? 'rgba(167,139,250,.08)' : 'transparent'; }}
                                >
                                  {/* Custom checkbox */}
                                  <div style={{
                                    width:18, height:18, borderRadius:5, flexShrink:0,
                                    border: sec ? '2px solid #a78bfa' : '2px solid rgba(255,255,255,.15)',
                                    background: sec ? '#a78bfa' : 'transparent',
                                    display:'flex', alignItems:'center', justifyContent:'center',
                                    transition:'all .15s',
                                  }}>
                                    {sec && <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                                  </div>
                                  <span style={{ fontSize:'.78rem', fontWeight: sec ? 700 : 400, color: sec ? '#a78bfa' : 'rgba(255,255,255,.55)', transition:'color .12s' }}>
                                    {g.uzun}
                                  </span>
                                </div>
                              );
                            })}
                            {/* Alt — Tümünü temizle */}
                            {seciliGunler.length > 0 && (
                              <div
                                onClick={() => setFormData(p => ({ ...p, allowedDays:[], _gunDropAcik:false }))}
                                style={{ padding:'9px 14px', borderTop:'1px solid rgba(255,255,255,.06)', cursor:'pointer', display:'flex', alignItems:'center', gap:6 }}
                                onMouseEnter={e => e.currentTarget.style.background='rgba(239,68,68,.06)'}
                                onMouseLeave={e => e.currentTarget.style.background='transparent'}
                              >
                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(239,68,68,.6)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                                <span style={{ fontSize:'.7rem', color:'rgba(239,68,68,.6)', fontWeight:600 }}>Tümünü Temizle</span>
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })()}

              {/* Açıklama */}
              <div style={{ marginBottom:24 }}>
                <div style={{ fontSize:'.62rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'1.4px', color:'rgba(255,255,255,.18)', marginBottom:6 }}>Müşteri Açıklaması</div>
                <div style={{ fontSize:'.67rem', color:'rgba(255,255,255,.22)', marginBottom:10 }}>
                  Maddeler <strong style={{color:'rgba(255,255,255,.45)'}}>1.</strong> <strong style={{color:'rgba(255,255,255,.45)'}}>2.</strong> <strong style={{color:'rgba(255,255,255,.45)'}}>3.</strong> ile başlasın. Madde içinde Enter ile alt satıra geçebilirsiniz.
                </div>
                <textarea
                  className="bm-inp"
                  key={`desc-${currentBonus?._id || 'new'}`}
                  defaultValue={(() => {
                    const arr = (formData.description || []).filter(s => s.trim());
                    if (!arr.length) return '';
                    return arr.map((s, i) => `${i + 1}. ${s}`).join('\n\n');
                  })()}
                  onBlur={e => {
                    const raw = e.target.value;
                    // Sadece "1. " "2. " gibi satır başı madde numaralarına göre böl
                    const maddeler = raw
                      .split(/\n(?=\d+\. )/)
                      .map(s => s.replace(/^\d+\.\s*/, '').trim())
                      .filter(Boolean);
                    setFormData(p => ({ ...p, description: maddeler }));
                  }}
                  rows={8}
                  placeholder={"1. Birinci madde...\nAlt satır devamı (isteğe bağlı)\n\n2. İkinci madde...\n\n3. Üçüncü madde..."}
                  style={{ ...inp, resize:'vertical', lineHeight:1.85, fontFamily:"'Outfit',sans-serif" }}
                />
                {(formData.description || []).filter(s => s.trim()).length > 0 && (
                  <div style={{ marginTop:7, fontSize:'.65rem', color:'rgba(167,139,250,.5)', display:'flex', alignItems:'center', gap:5 }}>
                    <span style={{ width:5, height:5, borderRadius:'50%', background:'#a78bfa', display:'inline-block' }} />
                    {(formData.description || []).filter(s => s.trim()).length} madde · Kaydet'e basınca güncellenir
                  </div>
                )}
              </div>

              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                <button type="button" onClick={() => setShowModal(false)} style={{ padding:'11px', borderRadius:11, border:'1px solid rgba(255,255,255,.08)', background:'rgba(255,255,255,.05)', color:'rgba(255,255,255,.5)', fontSize:'.82rem', fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>İptal</button>
                <button type="submit" style={{ padding:'11px', borderRadius:11, border:'none', background:'linear-gradient(135deg,#f27127,#c44b0a)', color:'#fff', fontSize:'.82rem', fontWeight:700, cursor:'pointer', fontFamily:'inherit', boxShadow:'0 4px 14px rgba(242,113,39,.25)' }}>Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ══ KATEGORİ MODAL ══ */}
      {showCatModal && (
        <div onClick={() => setShowCatModal(false)} style={{ position:'fixed', inset:0, zIndex:10001, background:'rgba(0,0,0,.8)', backdropFilter:'blur(10px)', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div onClick={e=>e.stopPropagation()} style={{ width:'100%', maxWidth:460, background:'#111318', border:'1px solid rgba(139,92,246,.18)', borderRadius:22, overflow:'hidden', boxShadow:'0 32px 80px rgba(0,0,0,.7)' }}>
            <div style={{ padding:'20px 24px 16px', borderBottom:'1px solid rgba(255,255,255,.05)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ width:38, height:38, borderRadius:10, background:'rgba(139,92,246,.12)', border:'1px solid rgba(139,92,246,.25)', display:'flex', alignItems:'center', justifyContent:'center', color:'#a78bfa' }}><FaLayerGroup /></div>
                <div>
                  <div style={{ fontWeight:700, fontSize:'.92rem', color:'#f8fafc' }}>Kategori Yönetimi</div>
                  <div style={{ fontSize:'.68rem', color:'rgba(255,255,255,.25)', marginTop:2 }}>Bonus kategorilerini ekleyin veya silin</div>
                </div>
              </div>
              <button onClick={() => setShowCatModal(false)} style={{ width:30, height:30, borderRadius:8, border:'none', cursor:'pointer', background:'rgba(255,255,255,.06)', color:'rgba(255,255,255,.35)', display:'flex', alignItems:'center', justifyContent:'center' }}><FaTimes /></button>
            </div>

            <div style={{ padding:'20px 24px 24px' }}>
              {/* Ekleme formu */}
              <form onSubmit={handleAddCat} style={{ display:'flex', gap:10, marginBottom:20 }}>
                <input className="bm-inp" type="text" placeholder="Yeni kategori adı..." value={newCatName} onChange={e=>setNewCatName(e.target.value)}
                  style={{ ...inp, flex:1 }} />
                <button type="submit" disabled={isSubmittingCat} style={{ padding:'10px 16px', borderRadius:10, border:'none', background:'linear-gradient(135deg,#a78bfa,#7c3aed)', color:'#fff', fontSize:'.79rem', fontWeight:700, cursor:'pointer', fontFamily:'inherit', whiteSpace:'nowrap' }}>
                  {isSubmittingCat ? <FaSync style={{ animation:'spin 1s linear infinite' }} /> : <><FaPlus style={{ marginRight:5 }} />Ekle</>}
                </button>
              </form>

              {/* Kategori listesi */}
              <div style={{ display:'flex', flexDirection:'column', gap:6, maxHeight:300, overflowY:'auto' }} className="bm-scroll">
                {categories.length === 0 && <div style={{ textAlign:'center', color:'rgba(255,255,255,.15)', fontSize:'.8rem', padding:'20px 0' }}>Henüz kategori yok</div>}
                {categories.map(cat => (
                  <div key={cat._id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 12px', borderRadius:10, background:'rgba(255,255,255,.03)', border:'1px solid rgba(255,255,255,.05)' }}>
                    <div>
                      <span style={{ fontSize:'.83rem', fontWeight:600, color:'#e2e8f0' }}>{cat.name}</span>
                      <span style={{ marginLeft:8, fontSize:'.65rem', color:'rgba(255,255,255,.25)' }}>ID: {cat.categoryId}</span>
                    </div>
                    <button onClick={() => handleDelCat(cat._id)} style={{ width:28, height:28, borderRadius:8, border:'none', cursor:'pointer', background:'rgba(239,68,68,.1)', color:'#f87171', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'.72rem', transition:'all .15s' }}><FaTrash /></button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer theme="dark" position="bottom-right" autoClose={2500} limit={3} />
    </div>
  );
};

export default BonusManagement;
